import React from 'react'


const DATA = [
    {
        icon: "/images/why-1.png",
        heading: "Effortless Consistency",
        para: "Maintain a unified brand tone across all tweets—automatically."
    },
    {
        icon: "/images/why-2.png",
        heading: "Time & Cost Savings:",
        para: "Reduce manual effort by up to 70%, freeing your team to focus on strategy and innovation."
    },
    {
        icon: "/images/why-3.png",
        heading: "Cutting-Edge AI",
        para: "Built on transformers and GAN models, Chinu AI delivers top-tier content generation and continuous learning."
    },
    {
        icon: "/images/why-4.png",
        heading: "Total Control or Full Automation",
        para: "Approve everything manually or let Chinu AI handle the heavy lifting—flexibility is yours."
    },
]

export default function WhyChoesUs() {
    return (
        <div className='p-[5vw]'>
            <div className='grid md:grid-cols-12 grid-cols-1 gap-5'>
                <div className='md:col-span-7'>
                    <h1 className="md:text-6xl text-3xl font-bold animate__fadeInLeft animate__animated wow">Why Choose <br /> Chinu AI?</h1>
                    <div className='grid grid-cols-2 gap-5 mt-10'>
                        {DATA.map((item, idx) => (
                            <div key={idx} className='space-y-3'>
                                <img src={item.icon} alt="" className='md:w-[6vw] w-[17vw] animate__swing wow animate__animated animate__infinite custom-duration' />
                                <h2 className='md:text-xl text-base font-medium animate__fadeInUp wow animate__animated'>{item.heading}</h2>
                                <p className='text-gray-400 font-light animate__fadeInUp wow animate__animated'>{item.para}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='md:col-span-5'>
                    <img src="/images/why.png" alt="" className='my-auto smooth_move' />
                </div>
            </div>
        </div>
    )
}
